import { useState as a, useEffect as s } from "react";
import { getHoopsLibraryLoader as i } from "./HoopsViewerLoader.utils.mjs";
const f = i(), p = (t) => {
  const [r, e] = a({});
  return s(() => {
    const c = new AbortController();
    return (async () => {
      if (!r.communicator)
        try {
          const o = await f(t, c);
          if (!o)
            throw new Error("No Hoops communicator!");
          e({
            communicator: o,
            error: void 0
          });
        } catch (o) {
          if (o instanceof Error) {
            if (o.name === "AbortError")
              return;
            e((n) => ({
              ...n,
              error: o
            }));
          }
        }
    })().catch(null), () => {
      c.abort();
    };
  }, [r.communicator, t]), r;
};
export {
  p as useHoopsScript
};
//# sourceMappingURL=HoopsViewerLoader.hooks.mjs.map
